import { useQuery } from "@tanstack/react-query";
import {
  InstallsTopUserCount,
  InstallsTopUsers,
} from "../../services/services";
import { useState } from "react";
import Loading from "../../components/Loading/Loading";
import InformationSmallBanner from "../../components/InformationSmallBanner/InformationSmallBanner";
import usersSvg from "../../svg/users.svg";
import ResponsiveDataList from "../../components/ResponsiveDataList/ResponsiveDataList";
import { SelectCustom } from "../../components/SelectCustom/SelectCustom";
import PersianDate from "../../components/PersianDate/PersianDate";
import { LeagueFormatter } from "../../components/LeagueFormatter/LeagueFormatter";
import CloseRedIconSvg from "../../svg/CloseRedIconSvg";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DateObject from "react-date-object";
import { GetUnixDate } from "../../components/GetUnixDate/GetUnixDate";
import { CampaignonvertUnixToGregorian } from "../../components/ConvertUnixToGregorian/ConvertUnixToGregorian";
import { useResponsivePageSize } from "../../hook/useResponsivePageSize";
import useSyncPageSize from "../../hook/useSyncPageSize";

const TopUsers = () => {
  // const [filters, setFilters] = useState({
  //   FromDate: "",
  //   ToDate: "",
  //   OrderBy: "",
  //   IsAscending: undefined,
  //   pageNumber: 1,
  //   pageSize: 14,
  // });
  // const [tempFilters, setTempFilters] = useState(filters);
  // const pageSize = useResponsivePageSize();
  // useSyncPageSize(filters, setFilters, pageSize);

  // const { data: topUsers, refetch } = useQuery({
  //   queryKey: ["InstallsTopUsers", filters],
  //   queryFn: () =>
  //     InstallsTopUsers({
  //       FromDate: filters.FromDate
  //         ? CampaignonvertUnixToGregorian(filters.FromDate)
  //         : null,
  //       ToDate: filters.ToDate
  //         ? CampaignonvertUnixToGregorian(filters.ToDate)
  //         : null,
  //       OrderBy: filters.OrderBy,
  //       IsAscending: filters.IsAscending,
  //       pageNumber: filters.pageNumber,
  //       pageSize: pageSize,
  //     }),
  //   select: (res) => res.data,
  //   staleTime: 60 * 60000,
  //   retry: false,
  //   enabled: true,
  // });
  // const { data: topUserCount } = useQuery({
  //   queryKey: ["InstallsTopUserCount"],
  //   queryFn: () => InstallsTopUserCount(),
  //   select: (res) => res.data,
  //   enabled: true,
  //   staleTime: 60 * 60000,
  //   retry: false,
  // });
  // const handleSearch = () => {
  //   setFilters(tempFilters);
  //   refetch();
  // };

  // const handleChange = (key, value) => {
  //   setTempFilters((prev) => ({
  //     ...prev,
  //     [key]: value,
  //   }));
  // };

  // const orderByOptions = [
  //   { label: "تعداد نصب", value: "installCount" },
  //   { label: "تاریخ نصب", value: "installDate" },
  // ];

  // const sortOrderBy = [
  //   { label: "بیشترین", value: "false" },
  //   { label: "کمترین", value: "true" },
  // ];

  // const columns = [
  //   {
  //     field: "userId",
  //     header: "شناسه",
  //     style: {
  //       textAlign: "right",
  //     },
  //   },
  //   {
  //     field: "userName",
  //     header: "نام کاربری",
  //     style: {
  //       textAlign: "right",
  //     },
  //   },
  //   {
  //     field: "phoneNumber",
  //     header: "شماره تلفن",
  //     style: {
  //       textAlign: "right",
  //     },
  //   },
  //   {
  //     field: "installCount",
  //     header: "تعداد نصب",
  //     style: {
  //       textAlign: "right",
  //     },
  //   },
  //   {
  //     field: "installDate",
  //     body: (rowData) => <PersianDate date={rowData.installDate} />,
  //     header: "تاریخ نصب",
  //     style: {
  //       textAlign: "right",
  //     },
  //   },
  //   {
  //     body: (rowData) => LeagueFormatter(rowData.league),
  //     header: "لیگ",
  //     style: { textAlign: "right" },
  //   },
  // ];

  // const itemTemplate = (item) => (
  //   <div
  //     key={item.id}
  //     className="card shadow-sm mb-3 p-3"
  //     style={{
  //       backgroundColor: "#f9f9f9",
  //       border: "1px solid #eee",
  //       direction: "rtl",
  //     }}
  //   >
  //     <div className="d-flex justify-content-between mb-1">
  //       <strong>شناسه:</strong>
  //       <span>{item.userId}</span>
  //     </div>
  //     <hr />
  //     <div className="mb-1">
  //       <strong>نام کاربری:</strong> {item.userName}
  //     </div>
  //     <div className="mb-1">
  //       <strong>شماره تلفن:</strong> {item.phoneNumber}
  //     </div>
  //     <div className="mb-1">
  //       <strong>تعداد نصب:</strong> {item.installCount}
  //     </div>
  //     <div className="mb-1">
  //       <strong>تاریخ نصب:</strong> <PersianDate date={item.installDate} />
  //     </div>
  //     <div className="mb-1">
  //       <strong>لیگ:</strong> {LeagueFormatter(item.league)}
  //     </div>
  //   </div>
  // );
  return (
    <div className="list-user">
      {/* {topUsers == undefined && topUserCount == undefined && <Loading />}
      <div>
        {topUserCount && (
          <div className="row">
            {topUserCount.items?.slice(0, 3).map((user, index) => {
              const gradients = [
                "linear-gradient(to bottom right,rgba(134, 160, 255, 0.82), #434ce6)",
                "linear-gradient(to bottom left,rgba(134, 160, 255, 0.82), #434ce6)",
                "linear-gradient(to right top,rgba(134, 160, 255, 0.82), #434ce6)",
              ];

              const titleMap = {
                1: "هفتگی",
                2: "ماهانه",
                3: "سالانه",
              };

              return (
                <div
                  key={user?.userId || index}
                  style={{ cursor: "pointer" }}
                  className="col-6 col-xl-4 col-md-5 mt-xl-0 mt-2"
                >
                  <InformationSmallBanner
                    label={user?.userName}
                    svg={
                      index === 0
                        ? usersSvg({
                            width: "60px",
                            height: "60px",
                            fill: "#fff",
                          })
                        : undefined
                    }
                    withoutImg={index !== 0}
                    value={user?.installCount || 0}
                    title={titleMap[user?.type] || "عنوان نامشخص"}
                    fontSizeCount="30px"
                    background={gradients[index]}
                    onClick={() => {
                      const url = `${window.location.origin}/#/user-information/?userId=${user?.userId}`;
                      window.open(url, "_blank", "noopener,noreferrer");
                    }}
                  />
                </div>
              );
            })}
          </div>
        )}
      </div>
      <div className=" card mt-3">
        <h5>برترین ها</h5>
        <div className="background-dataTable">
          <div className="row mt-2">
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <SelectCustom
                name="OrderBy"
                placeholder="مرتب کردن بر اساس"
                isClearable={true}
                isSearchable={false}
                unstyled={true}
                options={orderByOptions}
                value={
                  orderByOptions.find(
                    (item) => item.value === tempFilters.OrderBy
                  ) || null
                }
                onChange={(e) => {
                  setTempFilters({
                    ...tempFilters,
                    OrderBy: e ? e.value : null,
                  });
                }}
              />
            </div>
            {tempFilters.OrderBy && (
              <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
                <SelectCustom
                  name="IsAscending"
                  placeholder="مرتب سازی براساس"
                  isClearable={true}
                  isSearchable={false}
                  unstyled={true}
                  options={sortOrderBy}
                  value={
                    sortOrderBy.find(
                      (item) => item.value === tempFilters.IsAscending
                    ) || null
                  }
                  onChange={(e) => {
                    setTempFilters({
                      ...tempFilters,
                      IsAscending: e ? e.value : null,
                    });
                  }}
                />
              </div>
            )}
            <div className="col-12 col-xl-2 col-md-5 mt-md-0 mt-2">
              <div
                style={{
                  display: "inline-block",
                  position: "relative",
                }}
              >
                <DatePicker
                  containerStyle={{
                    height: "40px",
                    borderRadius: "8px",
                    color: "#4b5563",
                    fontSize: "1rem",
                    borderColor: "#c8c8c8",
                    borderWidth: "1px",
                    borderStyle: "solid",
                    width: "210px",
                    display: "flex",
                    paddingRight: "10px",
                    alignItems: "center",
                    boxShadow: "none",
                  }}
                  inputClass="no-outline"
                  placeholder="تاریخ را انتخاب کنید"
                  style={{ borderRadius: "8px", border: "none" }}
                  calendar={persian}
                  locale={persian_fa}
                  calendarPosition="bottom"
                  range
                  rangeHover
                  value={
                    tempFilters.FromDate && tempFilters.ToDate
                      ? [
                          new DateObject({
                            calendar: persian,
                            date: tempFilters.FromDate,
                          }),
                          new DateObject({
                            calendar: persian,
                            date: tempFilters.ToDate,
                          }),
                        ]
                      : ["", ""]
                  }
                  onChange={(e) => {
                    if (e.length === 2) {
                      handleChange("FromDate", GetUnixDate(e[0]));
                      handleChange("ToDate", GetUnixDate(e[1], true));
                    }
                  }}
                  clearable
                  format="YYYY/MM/DD"
                />

                <CloseRedIconSvg
                  onClick={() => {
                    setTempFilters({ FromDate: null, ToDate: null });
                  }}
                  style={{
                    cursor: "pointer",
                    width: "16px",
                    height: "16px",
                    position: "absolute",
                    left: "6px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 100,
                  }}
                />
              </div>
            </div>
            <div className="col-6 col-xl-2 col-md-5 d-flex align-items-end mt-md-0 mt-2">
              <button
                style={{
                  color: "#ffff",
                  background: "#86a0ff",
                  border: "0px",
                  width: "108px",
                  height: "39px",
                  borderRadius: "8px",
                  padding: "2px",
                }}
                onClick={handleSearch}
              >
                جستجو
              </button>
            </div>
          </div>

          <ResponsiveDataList
            dataKey="userId"
            data={topUsers?.items}
            columns={columns}
            itemTemplate={itemTemplate}
            dataViewHeader={<></>}
            className="farsi-monospace-digit "
            rows={filters.pageSize}
            pageNumber={filters.pageNumber}
            totalCount={topUsers?.totalCount}
            typeFilter={true}
            onPageChange={({ pageNumber }) => {
              setFilters((prev) => ({
                ...prev,
                pageNumber,
              }));
            }}
          />
        </div>
      </div> */}
    </div>
  );
};
export default TopUsers;
